import PricingPredictionResponse from '../../vo/PricingPredictionResponse'

export const ingressDummyTo = () => {
    return new PricingPredictionResponse({price: 1234.56, similarProperties: [], propertyData:{}});
}

export const ingressResponseTo = (serverResponse) => {
    return new PricingPredictionResponse({price: serverResponse.rentPricePrediction, similarProperties: serverResponse.similiarApartments, propertyData:serverResponse.apartmentData});
}

export const ingressSalesResponseTo = (serverResponse) => {
    return new PricingPredictionResponse({price: serverResponse.salePricePrediction, similarProperties: serverResponse.similiarApartments, propertyData:serverResponse.apartmentData});
}


// WEBPACK FOOTER //
// ./src/pricing/tranformer/import/pricingTransformer.js